import React, { useState, useEffect } from "react";

const ExploreStaysComingSoon = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date("2024-12-31T00:00:00"); // Set your target date here

    const intervalId = setInterval(() => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className="h-full flex items-center justify-center pr-20 bg-gradient-to-r from-yellow-200 to-pink-300 rounded-xl"
      style={{ height: "calc(100vh - 130px)" }}
    >
      <div className="text-center text-white">
        <h1 className="text-5xl font-extrabold mb-6 text-amber-800">
          Coming Soon
        </h1>
        <p className="text-xl mb-4 text-amber-700 font-light">
          A showcase of the best stays from around the world!
        </p>

        {/* <button className="mt-2 px-6 py-2 bg-white text-amber-600 rounded-full font-semibold hover:bg-stone-50 transition duration-300">
          Notify Me
        </button> */}
      </div>
    </div>
  );
};

export default ExploreStaysComingSoon;
